import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportService from "src/services/ReportService"
import FilterCustom from "./Filter"
import InventoryDetailModal from "../Modal/DetailModal" // modal mới cho tồn kho

function ListInventory({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)

  const fetchData = async (pagination, filter, keyword) => {
    setLoading(true)
    try {
      const res = await ReportService.getListInventoryB2B({
        page: pagination.current,
        per_page: pagination.pageSize,
        filter,
        keyword,
      })

      const list = res?.success?.data || []

      const formatted = list.map((item, index) => ({
        ...item,
        key: item.ID || index,
        sale_type: item.sale_type === "0" ? "Bán buôn" : "Bán lẻ",
        remain_sim: item.history?.reduce(
          (sum, h) => sum + (Number(h?.remain_sim) || 0),
          0,
        ),
      }))
      setDataSource(formatted)
      setPagination({
        ...pagination,
        total: res?.success?.total || 0,
      })
      setSummary(res?.success?.sim || {})
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])

  useEffect(() => {
    setParentFilter(filter)
    if (pagination.current !== 1) {
      setPagination(prev => ({ ...prev, current: 1 }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])

  const columns = [
    {
      title: "Mã đơn hàng",
      dataIndex: "export_code",
      align: "center",
    },
    {
      title: "Khách hàng",
      dataIndex: "customer",
      key: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    {
      title: "Số lượng SIM",
      dataIndex: "sim_quantity",
      key: "sim_quantity",
      align: "center",
    },
    {
      title: "Số lượng SIM còn lại",
      dataIndex: "remain_sim",
      key: "remain_sim",
      align: "center",
    },
    {
      title: "Ngày duyệt xuất kho",
      dataIndex: "approved_export_at",
      key: "approved_export_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
  ]
  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  const handleRowClick = record => {
    setSelectedRecord(record)
    setIsDetailModalOpen(true)
  }

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false)
    setSelectedRecord(null)
  }

  return (
    <div>
      <div style={{ display: "flex" }}>
        <FilterCustom setFilter={setFilter} setKeyword={setKeyword} />
      </div>

      {/* Tổng hợp */}
      <div style={{ width: "100%", display: "flex" }} className="px-2 p-md-0">
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.total_sim}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#28A745" }}>
          <strong>Đã bán: {summary.total_sold_sim}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000" }}>
          <strong>Tồn kho: {summary.total_remain_sim}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#0d8321ff" }}>
          <strong>SIM vật lý: {summary.usim}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#8039bbff" }}>
          <strong>E-SIM: {summary.esim}</strong>
        </div>
      </div>

      <TableCustom
        isPrimary
        columns={columns}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              handleRowClick(record?.ID)
            },
          }
        }}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />

      {selectedRecord && (
        <InventoryDetailModal
          open={isDetailModalOpen}
          onCancel={handleCloseDetailModal}
          recordId={selectedRecord}
        />
      )}
    </div>
  )
}

export default ListInventory
